import React from 'react';

const AuthContainer = ({ children, className = '' }) => {
  return (
    <div className={`auth-container flex items-center justify-center p-4 min-h-screen ${className}`}>
      <div className="w-full max-w-md">
        {children}
      </div>
    </div>
  );
};

export default AuthContainer;